module.exports = __webpack_public_path__ + "img/yzs.b8681eb6.png";